import { LookupModelSearchEvent } from "@mcleod/components";
import { AutogenLayoutTopCustomerReport } from "./autogen/AutogenLayoutTopCustomerReport";

export class TopCustomerReport extends AutogenLayoutTopCustomerReport {
    override onLoad(): void {
        this.textboxDateType.selectedItem = this.textboxDateType.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
    }

    switchCompareOnChange() {
        if(this.switchCompare.checked) {
            this.textboxDateTwo.enabled = true
            this.textboxDateTwo.required = true
            this.textboxDateTwo.dateDefault = this.textboxDateTwo.dateDefault
        }
        else {
            this.textboxDateTwo.enabled = false
            this.textboxDateTwo.required = false
            this.textboxDateTwo.clear()
        }
    }

    textboxDateTypeOnChange() {
        this.textboxDateOne.caption = "Period 1 " + this.textboxDateType.text
        this.textboxDateTwo.caption = "Period 2 " + this.textboxDateType.text
    }

    textboxCustomersBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.type_of = "C"
    }
    textboxCategoriesBeforeLookupModelSearch(event: LookupModelSearchEvent) {
        event.filter.customer = "Y"
    }
}
